var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-icon',{staticClass:"remove_dashboard_item",attrs:{"icon-pack":"material-icons","icon":"close"},on:{"click":function($event){return _vm.$emit('input')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }